import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const ease = [0.22, 1, 0.36, 1];

export const Areas = ({ locations }) => (
  <section id="areas" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <p className="uppercase tracking-[0.25em] text-flame font-heading font-bold text-sm mb-4">03 — Coverage</p>
        <h2 data-testid="areas-heading" className="font-heading font-black tracking-tighter text-navy text-3xl sm:text-4xl lg:text-5xl">
          Areas we serve
        </h2>
        <p className="text-slate-500 mt-6 text-base leading-relaxed max-w-md">
          Prime Pro Connect Services connects customers with trusted local service
          professionals in Huntsville, Madison, Decatur, Athens, Hazel Green, Cullman
          and surrounding North Alabama communities — expanding across Alabama and
          Tennessee city by city, only where we have real local professionals.
        </p>
        <div className="mt-8 inline-flex items-center gap-3 bg-[#F4F5F7] border border-border px-5 py-3">
          <span className="w-2 h-2 bg-flame" />
          <p className="text-sm font-medium text-navy">Tennessee — expanding soon</p>
        </div>
      </div>

      <div className="lg:col-span-7">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="areas-grid">
          {locations.map((l, i) => (
            <motion.div
              key={l.id}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.07, ease }}
            >
              <Link
                to={`/${l.state_slug}/${l.slug}`}
                data-testid={`area-link-${l.slug}`}
                className="group flex items-center gap-3 border border-border bg-white px-5 py-4 hover:-translate-y-0.5 hover:border-flame transition-[transform,border-color] duration-300"
              >
                <MapPin size={16} className="text-flame shrink-0" />
                <span className="font-heading font-bold text-navy text-sm lg:text-base tracking-tight">
                  {l.city}, AL
                </span>
                {l.is_primary && (
                  <span className="ml-auto text-[10px] uppercase tracking-widest text-flame font-bold">Core</span>
                )}
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Areas;
